import React from "react";
import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Check as CheckIcon } from '@vedmarket/ui-kit';
import { Close as CloseIcon } from '@vedmarket/ui-kit';

import ModalBig from "../modalBig";

import './modal-confirm.scss';

type Props = {
  isOpen: boolean;
  title: string;
  description: React.ReactNode;
  handleClose?: () => void;
  handleCloseWithoutSaving?: () => void;
  handleSave?: () => void;
}

const ModalConfirm = ({ isOpen, title, description, handleClose, handleCloseWithoutSaving, handleSave } : Props ) => {

  const { t } = useTranslation()

  return (
    <ModalBig
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      width={736}>
      <div className='modal-confirm'>
        <Typography variant='body1' className='modal-confirm__description'>
          {description}
        </Typography>
        <hr className='modal-confirm__line'/>
        <div className='modal-confirm__actions'>
          <Button
            variant='outlined'
            onClick={handleCloseWithoutSaving}
            startIcon={<CloseIcon style={{ width: '22px', height: '22px' }} />}
            sx={{ width: '308px' }}
          >{t('actions__text__logOutWithoutSaving')}</Button>
          <Button
            variant='contained'
            onClick={handleSave}
            startIcon={<CheckIcon style={{ width: '22px', height: '22px' }} />}
            sx={{ width: '308px' }}
          >{t('actions__text__saveAndExit')}</Button>
        </div>
      </div>
    </ModalBig>
  )
}

export default ModalConfirm
